// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"785":"1e053cc7","806":"cc555f27"}[chunkId] + ".chunk.css";
};